import React, {useEffect, useState} from "react";
import {AiOutlineClose, AiOutlineDoubleRight} from "react-icons/ai";
import axios from '../../../services/axiosInstance';
import {useTranslation} from "react-i18next";
import commonClose from "../../../assets/img/commonClose.png";

function ProdPriceAdminAddDetail({closeDetail, paySeqnum}) {
    const { t } = useTranslation();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [payList, setPayList] = useState([{}]);

    const selectPayinfoDetail = () => axios({
        method: 'get',
        url: '/order/selectTotalPayInfo/',
        headers: {
            Authorization: LCAT ? LCAT : SSAT
        },
        params: {
            seqNum: paySeqnum
        },
    })
        .then((response) => {
            setPayList(response.data)
        })
    useEffect(() => {
        const timer = setTimeout(() => {
            selectPayinfoDetail();
        })
        return () => {
            clearTimeout(timer);
        }
    }, [])

    return (
        <div className="bookContainer" style={{display: "flex", zIndex:"10"}}>
            <div className="bookFrame" style={{
                width: "600px",
                height: "700px",
                top: "calc(25vh - 120px)",
                left: "calc(50vw - 260px)",
                borderRadius: "5px"
            }}>
                <div style={{width: "100%", height: "100%"}}>
                    {/*상세헤더*/}
                    <div style={{height: "6%"}}>
                        <div style={{
                            height: "100%",
                            fontSize: "23px",
                            border: "solid",
                            borderWidth: "thin 1px",
                            color: "lightgray",
                            display: "flex"
                        }}>
                            <div style={{width: "92%", textAlign: "center", marginLeft: "55px"}}>
                                <p style={{
                                    color: "dimgrey",
                                    fontSize: "16px",
                                    width: "100%",
                                    marginTop: "7px"
                                }}>{t(`ppAadHeader`)}</p>
                            </div>
                            <div onClick={closeDetail} style={{width: "8%", textAlign: "center", cursor:"pointer"}}>
                                <img style={{width:"30px", height:"30px", opacity:"0.6"}} src={commonClose}/>
                            </div>
                        </div>
                    </div>
                    {/*상세바디*/}
                    <div style={{height: "94%", overflowY: "scroll"}}>

                        <div style={{
                            border: "solid",
                            margin: "60px 50px 40px 50px",
                            borderWidth: "thin 1px",
                            borderColor: "lightgray",
                            borderRadius: "6px"
                        }}>
                            <div style={{
                                borderBottom: "solid",
                                borderWidth: "thin 1px",
                                borderColor: "lightgray",
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                backgroundColor: "rgba(198,193,193,0.22)"
                            }}>
                                <span style={{
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    margin: "0 4px 0 10px",
                                    fontSize: "14px"
                                }}><AiOutlineDoubleRight/></span>
                                <span style={{
                                    height: "100%",
                                    fontSize: "13px",
                                    display: "flex",
                                    alignItems: "center",
                                    fontWeight: "bold"
                                }}>{t(`ppAadTx1`)}</span>
                            </div>
                            <div style={{margin: "10px", color: "dimgrey"}}>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    wordBreak: "break-all",
                                    marginTop: "10px",
                                    fontSize: "13px",
                                    marginBottom: "6px"
                                }}>
                                    <span>{t(`ppAadTx2`)}</span>
                                    <span style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", wordBreak:"break-all", width:"380px"}}>
                                        5번(슬로우앤드) 상품금액 및 8번(에바주니) 배송료 누락차액합산ㅋㅋㅋㅋㅋㅋ</span>
                                </div>
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    wordBreak: "break-all",
                                    fontSize: "13px",
                                    marginBottom: "6px"
                                }}>
                                    <span>{t(`ppAadTx3`)}</span>
                                    <span>{payList[0].ttProdExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ''}</span>
                                </div>
                            </div>
                        </div>
                        <div style={{margin: "60px 50px 0 50px", color: "dimgrey"}}>
                            <div style={{
                                height: "40px",
                                borderBottom: "solid",
                                borderWidth: "thin 1px",
                                borderColor: "lightgray",
                                display: "flex",
                                marginBottom: "5px"
                            }}><p style={{fontSize: "16px", height: "100%", paddingTop: "8px"}}>{t(`modHeader10`)}</p></div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px"
                            }}><span>{t(`ppAadTx4`)}</span><span>{payList[0].ttProdExpense?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ''}</span>
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px",
                                marginTop: "6px"
                            }}><span>{t(`myUseDep`)}</span><span>{payList[0].depUsePrice !== 0 ?
                                <span>- {payList[0].depUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}</span></div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px"
                            }}><span>{t(`myUsePt`)}</span><span>{payList[0].pointUsePrice !== 0 ?
                                <span>- {payList[0].pointUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}</span></div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                fontSize: "13px"
                            }}><span>{t(`modSHeader13`)}({payList[0].couponNm})</span><span>{payList[0].couponUsePrice !== 0 ?
                                <span>- {payList[0].couponUsePrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> : 0}</span>
                            </div>
                            <div style={{
                                height: "50px",
                                borderBottom: "solid",
                                borderWidth: "thin 1px",
                                borderColor: "lightgray",
                                display: "flex",
                                alignItems: "end",
                                justifyContent: "space-between",
                                wordBreak: "break-all",
                                padding: "5px",
                                marginBottom: "50px"
                            }}><span style={{fontSize: "16px", fontWeight: "bold"}}>modFinalPay</span>

                                    <span style={{
                                        color: "#FFAF34",
                                        fontWeight: "bold"
                                    }}>{payList[0]?.payStatus === "PS0" ? 0 : payList[0]?.lastPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProdPriceAdminAddDetail
